import React, { useEffect, useState } from "react";
import styles from "./StepThree.module.css";
import Header from "../../Header/Header";
// import ProgressBar from "./ProgressBar";
import { useNavigate } from "react-router-dom";
import config from "../../../config";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Slider } from "@mui/material";
import { showErrorToast } from "../../utils";
const StepThreeInsurance = () => {
    const navigate = useNavigate();
    // State variables to capture form input
    const [salary, setSalary] = useState(500);
    const [propertyUse, setPropertyUse] = useState("");
    // const [propertyType, setPropertyType] = useState(2500);
    const [deductible, setDeductible] = useState(2500);
    const storageInfo = JSON.parse(sessionStorage.getItem("insuranceInfo"));

    useEffect(() => {
        if (storageInfo?.coveragePreferences) {
            const info = storageInfo.coveragePreferences;
            setSalary(info.salary);
            setPropertyUse(info.propertyUse);
            setDeductible(info.deductible);
        }
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Validate form inputs
        if (!validateForm()) return;

        const authUserToken = localStorage.getItem("authUser");
        const authUser = authUserToken ? authUserToken.replace(/^"|"$/g, "") : "";

        try {
            sessionStorage.setItem("insuranceInfo", JSON.stringify({ ...storageInfo, coveragePreferences: { salary, deductible, propertyUse } }));

            navigate("/services/insurance-quote/step-4");

            // const response = await fetch(`${config.get("API_URL")}/api/personal_info`, {
            //     method: "POST",
            //     headers: {
            //         "Content-Type": "application/json",
            //         Authorization: `Bearer ${authUser}`,
            //     },
            //     body: JSON.stringify({
            //         first_name: firstName,
            //         last_name: lastName,
            //         email: email,
            //         phone_number: phoneNumber,
            //         address: address,
            //         unit_number: unitNumber,
            //     }),
            // });
            // const responseData = await response.json(); // Parse the response body
            // if (response.ok) {
            //     console.log("Response:", responseData); // Log the response
            //     showSuccessToast("Form submitted successfully!");
            //     navigate("/services/insurance-quote/step-2");
            // } else {
            //     console.log("Error Response:", responseData); // Log the error response
            //     showErrorToast(`Failed to submit: ${responseData.message || "Please try again."}`);
            // }
        } catch (error) {
            console.error("Error submitting the form:", error);
            showErrorToast("An error occurred. Please try again.");
        }
    };

    useEffect(() => {
        document.title = `Insurance | ${config.get("COMPANY_NAME")}`;
    }, []);

    const handleSliderChange = (setter) => (event, newValue) => {
        setter(newValue);
    };

    const validateForm = () => {
        if (!propertyUse) {
            showErrorToast("Please fill in all fields.");
            return false;
        }
        // // Email validation
        // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        // if (!emailRegex.test(email)) {
        //     showErrorToast("Please enter a valid email address.");
        //     return false;
        // }

        return true; // If everything is valid
    };

    return (
        <div className={`${styles.container} tw-bg-background_color`}>
            <main className={`${styles.mainContent} max-sm:tw-overflow-y-auto`}>
                <Header title="Insurance Quote" />
                <section className={styles.formSection}>
                    {/* <ProgressBar currentStep={1} totalSteps={7} /> */}
                    <div className={styles.formContainer}>
                        <h1 className={styles.formTitle}>Customize Your Coverage</h1>
                        <p className={`${styles.formDescription} tw-text-justify`}>
                            Your property's purpose shapes its insurance requirements. Whether it’s your primary home, a vacation retreat, or an
                            investment property, we’ll ensure you get the right coverage for complete peace of mind.
                        </p>
                        <form className={styles.generalForm} onSubmit={handleSubmit}>
                            <div className={`${styles.formRow} `}>
                                <div className={styles.fieldContainer}>
                                    <label className={styles.fieldLabel}>Property Use</label>
                                    <select
                                        id="options"
                                        value={propertyUse}
                                        onChange={(event) => setPropertyUse(event.target.value)}
                                        className={`${styles.fieldInput}`}
                                    >
                                        <option value="" disabled>
                                            Select an option
                                        </option>
                                        <option value="PrimaryHome">Primary Home</option>
                                        <option value="secondaryHome">Secondary Home</option>
                                        <option value="investmentProperty">Investment Property</option>
                                    </select>
                                </div>

                                <div className="tw-flex tw-gap-5 max-sm:tw-flex-wrap">
                                    <div className={`${styles.fieldContainer} tw-px-2`}>
                                        <label className={styles.fieldLabel}>Property Value</label>
                                        <Slider
                                            value={salary}
                                            onChange={handleSliderChange(setSalary)}
                                            min={500}
                                            max={5000}
                                            marks={[
                                                { value: 500, label: "$500" },
                                                { value: 5000, label: "$5k" },
                                            ]}
                                            valueLabelDisplay="auto"
                                            valueLabelFormat={(value) => `$${value}`}
                                            className="tw-text-primary"
                                        />
                                    </div>
                                    <div className={`${styles.fieldContainer} tw-px-2`}>
                                        <label className={styles.fieldLabel}>Deductible</label>
                                        <Slider
                                            value={deductible}
                                            onChange={handleSliderChange(setDeductible)}
                                            min={100}
                                            max={1000}
                                            marks={[
                                                { value: 100, label: "100k" },
                                                { value: 1000, label: "1m" },
                                            ]}
                                            valueLabelDisplay="auto"
                                            valueLabelFormat={(value) => `${value}k`}
                                            className="tw-text-primary"
                                        />
                                    </div>
                                </div>
                            </div>
                            {/* <p className="tw-text-secondary tw-italic">
                                Your property’s use and type significantly influence your insurance options and rates{" "}
                            </p> */}

                            <button type="submit" className={`${styles.submitButton}  tw-bg-primary hover:tw-bg-primary_hover`}>
                                Next: Coverage Options{" "}
                            </button>
                        </form>
                    </div>
                </section>
            </main>
        </div>
    );
};

export default StepThreeInsurance;
